import { render } from "./UploadLimitModalAlertComponent.vue?vue&type=template&id=2460c020&ts=true"
import script from "./UploadLimitModalAlertComponent.vue?vue&type=script&lang=ts"
export * from "./UploadLimitModalAlertComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__